import { createReducer } from '@reduxjs/toolkit';

import { noop } from '@constants/general';

import {
  CONVERSION_TOOL_MAPPING_EDIT_RESET,
  CONVERSION_TOOL_MAPPING_EDIT_START,
  CONVERSION_TOOL_MAPPING_EDIT_SUCCESS,
  CONVERSION_TOOL_MAPPING_EDIT_FAILURE,
  CONVERSION_TOOL_MAPPING_FETCH_START,
  CONVERSION_TOOL_MAPPING_FETCH_FAILURE,
  CONVERSION_TOOL_MAPPING_FETCH_SUCCESS,
} from './conversionToolMappingEdit.const';

export const initialState = {
  model: {
    mapping: {
      columnMap: {},
      filingType: '',
      vatNumber: '',
      headerStart: 0,
      rowStart: 0,
      name: '',
      id: '',
    },
    fields: [],
  },
  meta: { isSaving: false, isLoading: false, hasError: false, errorMessage: '' },
};

const conversionToolMappingEditReducer = createReducer(initialState, builder => {
  builder
    .addCase(CONVERSION_TOOL_MAPPING_EDIT_RESET, () => initialState)
    .addCase(CONVERSION_TOOL_MAPPING_EDIT_START, state => {
      state.meta.isSaving = true;
      state.meta.hasError = false;
      state.meta.errorMessage = '';
    })
    .addCase(CONVERSION_TOOL_MAPPING_EDIT_SUCCESS, state => {
      state.meta.isSaving = false;
    })
    .addCase(CONVERSION_TOOL_MAPPING_EDIT_FAILURE, state => {
      state.meta.isSaving = false;
    })
    .addCase(CONVERSION_TOOL_MAPPING_FETCH_START, state => {
      state.meta.isLoading = true;
      state.meta.hasError = false;
      state.meta.errorMessage = '';
    })
    .addCase(CONVERSION_TOOL_MAPPING_FETCH_SUCCESS, (state, { payload = {} }) => {
      state.meta.isLoading = false;
      state.model.mapping = payload.mapping;
      state.model.fields = payload.fields;
    })
    .addCase(CONVERSION_TOOL_MAPPING_FETCH_FAILURE, (state, { payload = '' }) => {
      state.meta.isLoading = false;
      state.meta.hasError = true;
      state.meta.mapping = {};
      state.meta.fields = [];
      state.meta.errorMessage = payload.errorMessage;
    })
    .addDefaultCase(noop);
});

export default conversionToolMappingEditReducer;
